import OtpInput from 'react-otp-input';

import { cx } from '@emotion/css';
import { pinCx } from './styles';
import { useEffect, useState } from 'react';

interface PinInputProps {
  value?: string;
  onChange: (otp: string) => void;
  numInputs?: number;
  error?: boolean;
}

const PinComponent = ({
  value,
  numInputs = 6,
  onChange,
  error,
}: PinInputProps) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowError(error || false);
  }, [error]);

  return (
    <div className={pinCx}>
      <OtpInput
        value={value}
        onChange={(otp) => {
          setShowError(false);
          onChange(otp);
        }}
        numInputs={numInputs}
        inputType='password'
        shouldAutoFocus
        containerStyle='otp-container'
        renderInput={(inputProps, index) => (
          <input
            {...inputProps}
            type='password'
            pattern='[0-9]*'
            inputMode='numeric'
            autoComplete='off'
            className={cx('otp-input', {
              filled: index < (value?.length || 0),
              error: showError,
            })}
          />
        )}
      />
    </div>
  );
};

export default PinComponent;
